import { DOC_SYNC_FAILURE_CLASS } from '@streamlain/doc-sync-taxonomy';

export interface WorkspaceSyncFailures {
  syncIsolatedFailures?: readonly { readonly failureClass: string }[];
}

/** A doc of the workspace waits for free storage; its changes stay local. */
export function hasStorageFullSyncFailure(
  state: WorkspaceSyncFailures | null | undefined
): boolean {
  return (
    state?.syncIsolatedFailures?.some(
      failure => failure.failureClass === DOC_SYNC_FAILURE_CLASS.StorageFull
    ) ?? false
  );
}

/**
 * The workspace has no free storage: its plan quota is used up (percent is
 * capped at 100) or the server refused a doc of it for storage.
 */
export function isWorkspaceStorageFull(
  usedPercent: number | null,
  syncFailures: WorkspaceSyncFailures | null | undefined
): boolean {
  return (
    (usedPercent !== null && usedPercent >= 100) ||
    hasStorageFullSyncFailure(syncFailures)
  );
}
